import React, {Fragment} from 'react';
import DataflowBuilderList from './list';

const DataflowBuilder = () =>
  <Fragment>
    <Fragment>
      <DataflowBuilderList/>
    </Fragment>
  </Fragment>;

export default DataflowBuilder;



// WEBPACK FOOTER //
// ./src/scenes/data-manager/dataflow-builder/index.jsx